export const activeUserListConstants={
    GET_ACTIVE_USER_LIST_REQUEST:"GET_ACTIVE_USER_LIST_REQUEST",
    GET_ACTIVE_USER_LIST_SUCCESS:"GET_ACTIVE_USER_LIST_SUCCESS",
    GET_ACTIVE_USER_LIST_FAILURE:"GET_ACTIVE_USER_LIST_FAILURE",

    //show dashboard data
    GET_SHOWDASHBOARD_DATA_REQUEST:"GET_SHOWDASHBOARD_DATA_REQUEST",
    GET_SHOWDASHBOARD_DATA_SUCCESS:"GET_SHOWDASHBOARD_DATA_SUCCESS",
    GET_SHOWDASHBOARD_DATA_FAILURE:"GET_SHOWDASHBOARD_DATA_FAILURE",

    UPDATE_USER_STATUS_REQUEST:"UPDATE_USER_STATUS_REQUEST",
    UPDATE_USER_STATUS_SUCCESS:"UPDATE_USER_STATUS_SUCCESS",
    UPDATE_USER_STATUS_FAILURE:"UPDATE_USER_STATUS_FAILURE",
}